<template>
    <div>
        <navigation-bar Close/>
        <div class="customerService main">
            <list-container>
                <category-content
                        v-for="(item, key) in processList"
                        :key="key"
                        class="custom-content"
                >
                    <div class="listItem">
                        <small class="font-weight-light">{{ item.category }}</small>
                        <div class="list-header d-flex">
                            <div class="list-title is-deco">{{ item.title }}</div>
                            <small class="ml-auto">{{ item.timestamp }}</small>
                        </div>
                        <div class="list-content my-3">
                            {{ item.content }}
                        </div>
                        <div class="list-footer">
                            <div v-if="item.status === 'reply'" class="status is-reply">
                                <span> 已回覆 </span>
                            </div>
                            <div v-if="item.status === 'noreply'" class="status is-noreply">
                                <span> 待回覆 </span>
                            </div>
                            <div v-if="item.status === 'closed'" class="status is-closed">
                                <span> 已關閉留言 </span>
                            </div>
                            <div class="viewAndReplay">查看／回覆</div>
                        </div>
                    </div>
                </category-content>
            </list-container>
            <el-row class="pb-3 text-center">
                <el-button round class="footer-btn confirm w-50">我要留言</el-button>
            </el-row>
        </div>
    </div>

</template>

<script>
import CategoryContent from "@/components/category/Content.vue";
import ListContainer from "@/components/lists/Container.vue";
export default {
  name: "Process",
  components: {
    CategoryContent,
    ListContainer,
  },
  data() {
    return {
      processList: [
        {
          category: "帳號相關",
          title: "我是標題",
          timestamp: "2020-06-13 10:00",
          content:
            "內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容...",
          status: "reply",
        },
        {
          category: "帳號相關",
          title: "我是標題",
          timestamp: "2020-06-13 10:00",
          content:
            "內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容...",
          status: "noreply",
        },
        {
          category: "帳號相關",
          title: "我是標題",
          timestamp: "2020-06-13 10:00",
          content:
            "內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容...",
          status: "closed",
        },
        {
          category: "帳號相關",
          title: "我是標題",
          timestamp: "2020-06-13 10:00",
          content:
            "內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容...",
          status: "closed",
        },
        {
          category: "帳號相關",
          title: "我是標題",
          timestamp: "2020-06-13 10:00",
          content:
            "內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容內容...",
          status: "closed",
        },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped src="@/less/service.less"/>